import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { debounceTime } from 'rxjs';
import { generateUUID } from 'src/app/core/generators/generateUUID';
import { AuthService } from 'src/app/services/AuthService/auth.service';
import {
  ICreateCarretaUpload,
  IGetCarreta
} from 'src/app/services/CarretaService/carreta.model';
import { CarretaService } from 'src/app/services/CarretaService/carreta.service';
import { IGetTipoCarreta } from 'src/app/services/TipoCarretaService/tipoCarreta.model';
import { TipoCarretaService } from 'src/app/services/TipoCarretaService/tipoCarreta.service';
import { UploadService } from 'src/app/services/UploadService/upload.service';
import Swal from 'sweetalert2';

import { ITabelaCarreta } from './listagem-carreta-model';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';

type IOptions = {
  name: string;
  value: string | number;
};
@Component({
  selector: 'app-listagem-carreta',
  templateUrl: './listagem-carreta.component.html',
  styleUrls: ['./listagem-carreta.component.scss']
})
export class ListagemCarretaComponent {
  isLoading: boolean = false;
  form = this._inicializarFormulario();
  numeroPagina: number = 0;
  tableData: ITabelaCarreta[] | Array<any> = [];
  pesquisaParams = {
    TxPesquisar: '',
    DtInicio: '',
    DtFim: '',
    Pagina: 0,
    TamanhoPagina: 20
  };
  maxPages: number = 1;
  expandirCardsMobile: boolean = true;
  guid = generateUUID();
  id: number = Number(localStorage.getItem('id'));

  tipoCarretaOptions: IOptions[] = [
    {
      name: '',
      value: ''
    }
  ];

  tableColumns = [
    { header: 'Código', key: 'codigo', type: 'text' },
    { header: 'Placa carreta', key: 'placaCarreta', type: 'text' },
    {
      header: 'Suspender',
      key: 'ativo',
      type: 'checkbox',
      action: (item: any) => this.suspenderCarreta(item)
    },
    {
      header: 'Ações',
      key: 'actions',
      type: 'buttons',
      buttons: [
        {
          label: 'Visualizar',
          img: 'assets/eye-icon.png',
          action: (item: any) => this.visualizarCarreta(item)
        },
        {
          label: 'Editar',
          img: 'assets/edit.svg',
          action: (item: any) => this.editarCarreta(item),
          condition: (item: any) => this.permitirEditar(item)
        },
        {
          label: 'Excluir',
          img: 'assets/trashcan.png',
          action: (item: any) => this.excluirCarreta(item)
        }
      ]
    }
  ];

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private carretaService: CarretaService,
    private authService: AuthService,
    private uploadService: UploadService,
    private tipoCarretaService: TipoCarretaService,
    private swalAlert: SwalAlertService
  ) {}

  private _inicializarFormulario() {
    const form = this.fb.group({
      TX_PLCA_CRRT: this.fb.control('', {
        nonNullable: true,
        validators: [Validators.required]
      })
    });
    return form;
  }

  editarCarreta(item: any) {
    const queryParams = {
      ...item,
      modoCarreta: 'Editar'
    };
    this.router.navigate(['motorista-externo/cadastro/carreta'], {
      queryParams: queryParams
    });
  }

  visualizarCarreta(item: any) {
    const queryParams = {
      ...item,
      modoCarreta: 'Visualizar'
    };
    this.router.navigate(['motorista-externo/cadastro/carreta'], {
      queryParams: queryParams
    });
  }

  ngOnInit() {
    this.getCarreta();
    this.getTipoCarreta();
  }

  ngAfterViewInit(): void {
    this.form.valueChanges.pipe(debounceTime(300)).subscribe(() => {
      this.getCarreta();
    });
  }

  navegarCarreta() {
    this.router.navigate(['motorista-externo/cadastro/carreta']);
  }

  mudarPagina(pagina: number) {
    this.pesquisaParams.Pagina = pagina;
    this.numeroPagina = pagina;
    this.getCarreta(pagina + 1);
  }

  formatarCampos(campo: string | number | Date): string {
    return campo === null || campo === '' ? 'Não Informado' : String(campo);
  }

  getCarreta(pageNumber?: number) {
    this.isLoading = true;
    const TX_PLCA_CRRT = String(this.form.controls.TX_PLCA_CRRT.value);
    this.authService.dadoLogin$.subscribe(({ idEmpresa }) => {
      this.carretaService
        .GetCarreta({
          placa: TX_PLCA_CRRT,
          tipoCarreta: 0,
          idEmpresa,
          pageNumber,
          pageSize: 20,
          status: 0
        })
        .subscribe({
          next: (response: IGetCarreta) => {
            this.isLoading = false;
            this.tableData = response.ITEMS.map(item => {
              return {
                codigo: item.PK_CRRT ?? 0,
                placaCarreta: String(item.TX_PLCA_CRRT),
                tipoCarreta: item.NM_TIPO_CRRT,
                empresa: item.FK_EPSA,
                ativo: item.NU_STTS_CRRT == 1 ? false : true,
                situacao: item.NU_STTS_CRRT,
                externo: 0
              };
            });
            this.maxPages = response.TOTAL_PAGES;
          },
          error: (_error: any) => {
            this.isLoading = false;
          }
        });
    });
  }

  getTipoCarreta(): void {
    this.tipoCarretaService.GetTipoCarreta().subscribe(response => {
      this.tipoCarretaOptions = response.map((x: IGetTipoCarreta) => {
        return {
          name: x.NM_TIPO_CRRT,
          value: x.PK_TIPO_CRRT
        };
      });
    });
  }

  excluirCarreta(item: any) {
    this.swalAlert.showAlert(
      'Atenção!',
      'Deseja realizar a exclusão?',
      'warning',
      true,
      true,
      {
        cancelButtonText: 'Cancelar',
        cancelButtonColor: 'red',
        confirmButtonColor: 'green',
        confirmButtonText: 'Confirmar'
      },
      () => {
        this.carretaService.PatchCarretaEmpresa(item.codigo, 0).subscribe(
          response => {
            this.swalAlert.showAlert(
              'Sucesso!',
              'Excluído com sucesso.',
              'success',
              false,
              false,
              undefined
            );
            this.getCarreta(this.numeroPagina + 1);
          },
          error => {}
        );
      }
    );
  }

  suspenderCarreta(item: any) {
    let statusCarreta: number;

    statusCarreta = item.situacao == 1 ? 2 : 1;

    this.carretaService
      .PatchCarretaEmpresa(item.codigo, statusCarreta)
      .subscribe(
        response => {
          this.swalAlert.showAlert(
            'Sucesso!',
            `${
              statusCarreta == 1 ? 'Remoção da suspensão' : 'Suspensão'
            } realizada com sucesso.`,
            'success',
            true,
            true,
            {
              confirmButtonColor: 'green',
              confirmButtonText: 'Ok'
            },
            () => {
              this.getCarreta(this.numeroPagina + 1);
            }
          );
        },
        error => {}
      );
  }

  uploadArquivo(field: any) {
    this.isLoading = true;
    this.guid = generateUUID();
    const base64 = field.split(',')[1];

    const body: ICreateCarretaUpload = {
      ReportBase64: base64,
    };

    if (this.authService.getCurrentUserType() === 'PF') {
      body.FK_MTRT_EXTR = this.id;
    } else {
      body.FK_EPSA = this.id;
    }

    this.uploadService.createByUpload(body, this.guid, 'carreta').add(() => {
      this.isLoading = false;
      this.getCarreta(this.numeroPagina + 1);
    });
  }

  downloadExcel(): void {
    this.uploadService.downloadTemplateUpload('carreta');
  }

  permitirEditar(item: any): boolean {
    const status: boolean = item.situacao == 1 ? true : false;
    return status;
  }
}

